// extracted by mini-css-extract-plugin
module.exports = {"row1":"MaterialsExpenditureForm_row1__b23Uf","form":"MaterialsExpenditureForm_form__3p4-E","label":"MaterialsExpenditureForm_label__2NEd8"};